import React, { useState, useEffect } from 'react';

const LazyImg = React.memo(({ src, style, fallback = null, fallbackAlways = false, ...rest }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [source, setSource] = useState('');

  useEffect(() => {
    if (typeof src === 'string' && src) {
      const t = setTimeout(() => {
        const imageToLoad = new Image();
        imageToLoad.src = src;
        imageToLoad.onload = () => {
          setSource(src);
          setIsLoading(false);
        };
        
        if (fallbackAlways) {
          setIsLoading(true);
        }
      }, 50);
      return () => clearTimeout(t);
    }
  }, [src, fallbackAlways]);

  return isLoading ? fallback : (
    <img
      alt=""
      {...rest}
      src={source}
      style={{
        ...style,
        transition: 'opacity .15s linear',
      }}
    />
  );
});

export default LazyImg;
